import api from "./api";

function hasUserAuth() {
    const token = localStorage.getItem("user_token") || localStorage.getItem("token");
    return Boolean(token);
}

// Toggle favorite status for a product
export const toggleFavoriteApi = async (productId) => {
    return await api.post("/api/v1/users/favorites/toggle", { productId });
};

// Get all favorite products for the user (ไม่ยิงถ้าไม่มี auth)
export const getFavoritesApi = async () => {
    if (!hasUserAuth()) return { data: { success: true, data: [] } };
    return await api.get("/api/v1/users/favorites");
};

// Check if a specific product is favorited (ไม่ยิงถ้าไม่มี auth)
export const checkFavoriteApi = async (productId) => {
    if (!hasUserAuth()) return { data: { success: true, isFavorite: false } };
    return await api.get(`/api/v1/users/favorites/${productId}/check`);
};
